import { Tabs as TabsCore } from '@studiometa/ui';

/**
 * Tabs
 */
export default class Tabs extends TabsCore {
  /**
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Tabs',
  };

  /**
   * Set active item
   * @param {number} index item to active
   */
  setActiveItem(index) {
    this.disableItem(this.items[0]);
    this.enableItem(this.items[index]);
  }
}
